import { render, staticRenderFns } from "./DemographicsAdditional.vue?vue&type=template&id=3f8a1eb2&scoped=true"
import script from "./DemographicsAdditional.vue?vue&type=script&lang=js"
export * from "./DemographicsAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a1eb2",
  null
  
)

export default component.exports